var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 25,
    width: 25.6,
    xmlns: "http://www.w3.org/2000/svg",
    className: "social-link-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 37 0 L 5 0 C 2.24 0 0 2.24 0 5 L 0 37 C 0 39.76 2.24 42 5 42 L 37 42 C 39.76 42 42 39.76 42 37 L 42 5 C 42 2.24 39.76 0 37 0 Z M 13 16 L 13 35 L 7 35 L 7 16 L 13 16 Z M 7 10.47 C 7 9.07 8.2 8 10 8 C 11.8 8 12.93 9.07 13 10.47 C 13 11.87 11.88 13 10 13 C 8.2 13 7 11.87 7 10.47 Z M 35 35 L 29 35 C 29 35 29 25.74 29 25 C 29 23 28 21 25.5 20.96 L 25.42 20.96 C 23 20.96 22 23.02 22 25 C 22 25.91 22 35 22 35 L 16 35 L 16 16 L 22 16 L 22 18.56 C 22 18.56 23.93 16 27.81 16 C 31.78 16 35 18.73 35 24.26 L 35 35 Z",
    transform: "scale(0.6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.bba33ed92ce8fb22b0a15a0f35a833eb.svg";
export { ForwardRef as ReactComponent };